import { usePOCManagement } from '@/hooks/admin/usePOCManagement';
import DeletePOCBaseDialog from './DeletePOCBaseDialog';

export function DeleteAmplifyPOCDialog({ poc, isOpen, onClose, onSuccess }) {
  const { removeAmplifyPOC } = usePOCManagement();

  const handleDelete = async () => {
    await removeAmplifyPOC(poc.id);
    onSuccess();
  };

  return (
    <DeletePOCBaseDialog
      poc={poc}
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleDelete}
      title="Delete Amplify POC"
      confirmLabel="Delete Amplify POC"
    />
  );
}

export default DeleteAmplifyPOCDialog;
